import React, { useState, useRef, useEffect } from "react";
import gsap from "gsap";

// Helper function to check if the screen width is smaller than a specified value
const isSmallScreen = () => window.innerWidth <= 768;

export const Features = (props) => {
  // Set initial state based on screen size
  const [isSmall, setIsSmall] = useState(isSmallScreen());

  // Update state when window is resized
  useEffect(() => {
    const handleResize = () => setIsSmall(isSmallScreen());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Define styles for small screens
  const smallScreenStyle = {
    padding: "30px",
  };

  // Define styles for larger screens (default)
  const defaultStyle = {
    padding: "5px",
    marginBottom: "10px",
    backgroundColor: "white",
    color: "black",
    borderRadius: "8px",
    overflow: "hidden",
    transform: "translateZ(0)",
  };

  // Merge styles conditionally
  const featureItemStyle = isSmall ? { ...defaultStyle, ...smallScreenStyle } : defaultStyle;

  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2 className="heading mt-5">Our Solutions</h2>
          <p></p>
        </div>
        <div className="row" style={{ margin: "-15px" }}>
          {props.data
            ? props.data.map((d, i) => (
                <FeatureItem key={`${d.title}-${i}`} data={d} featureItemStyle={featureItemStyle} featureId={`feature-${i}`} />
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};

// FeatureItem component to render individual feature cards
const FeatureItem = ({ data, featureItemStyle, featureId }) => {
  const [showMore, setShowMore] = useState(false);
  const cardRef = useRef(null);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const handleMouseEnter = () => {
    gsap.to(cardRef.current, {
      scale: 1.1,
      zIndex: 1,
      backgroundColor: "maroon",
      color: "white",
      duration: 0.3,
      ease: "power3.out",
    });
  };

  const handleMouseLeave = () => {
    gsap.to(cardRef.current, {
      scale: 1,
      zIndex: 0,
      backgroundColor: "white",
      color: "black",
      duration: 0.3,
      ease: "power3.out",
    });
  };

  return (
    <div
      id={featureId}
      className="col-xs-12 col-lg-3 col-md-6 col-sm-12 feature-item"
      style={featureItemStyle}
      ref={cardRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img
        className="img"
        src={data.image}
        alt=""
        style={{
          maxWidth: "100%",
          borderRadius: "8px",
          marginBottom: "10px",
        }}
      />
      <p className="title" style={{ fontWeight: "bold" }}>
        {data.title}
      </p>
      <p className="title text-left">
        {showMore ? data.text : truncateText(data.text, 300)}
        <button
          onClick={toggleShowMore}
          style={{
            marginLeft: "10px",
            cursor: "pointer",
            background: "none",
            border: "none",
            color: "orange",
          }}
        >
          {showMore ? "Show less" : "Show more"}
        </button>
      </p>
      <ul className="solution-list">
        <a href="#features" style={{ color: "lightblue" }}>
          <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
        </a>
      </ul>
    </div>
  );
};

// Helper function to truncate text
const truncateText = (text, charLimit) => {
  if (text.length > charLimit) {
    return text.substring(0, charLimit) + "...";
  }
  return text;
};
